module.exports = __webpack_public_path__ + "img/14.348232e0.png";